import './App.css';
import './proConnect.css';
import React, { useEffect, useState } from 'react';
import RouteComponent from './setup/route.component';
import { ToastContainer} from 'react-toastify';
import { useSelector } from 'react-redux'; 
import NoInternetConnection from './components/common/NoInternectConnection';
import { Auth } from 'aws-amplify'; 
import AWS from 'aws-sdk';
import { AWSLoadConfigHandler } from '../src/components/helper/commonfunctions';

function App() {

  const [isAwsReady, setIsAwsReady] = useState(false);
  const currentThemeValue = useSelector((state) => state.currentTheme.value);
  const showCurrentTheme = currentThemeValue ==="D" ? "dark" : "light"; 
    const AWSGetCredentials = async () => {
        try {
            let credentials = await AWSLoadConfigHandler();
            AWS.config.update({
                accessKeyId: credentials.accessKey,
                secretAccessKey: credentials.secretKey,
                region: process.env.REACT_APP_AWS_Region,
            });
            setIsAwsReady(true);
        } catch (error) {
            console.error("Failed to load AWS credentials:", error);
        }
    };


    useEffect(() => {

    console.log("22092025");

    AWSGetCredentials()
    }, []);

    if (!isAwsReady) {
      return <div className="dataLoader"></div>;
    }


  return (
    <>
    <NoInternetConnection>
      <RouteComponent />
      <ToastContainer theme={showCurrentTheme} autoClose={1000}  />
    </NoInternetConnection>
    </>
 
  );
}

export default App;
